import { URLParamBuilder } from '@/utils/functions';
import * as PATHS from '@/constants/path';
import { request } from '@/services/api/request';
import { getCleanServicePayload } from '@/utils/location';
import {
  AddAgentToBranchRequest,
  CreateBranchRequest,
  DeleteBranchRequest,
  DeleteServiceRequest,
  GetAgentsRequest,
  GetBranchRequest,
  GetBranchServicesRequest,
  GetServiceRequest,
  UpdateServiceRequest,
} from '@/typings/api/getLocations';
import { CreateResourceRequest, DeleteResourceRequest } from '@/typings/api/resources';
import { DeleteUserRequest } from '@/typings/api/user';

// region Fetch Branch Services
export function fetchBranchesRequest({query}) {
  const url = URLParamBuilder(PATHS.GET_BRANCHES, {
    queryString: query
  })

  return request<GetBranchServicesRequest["response"]>(url, {
    method: 'GET'
  });
}
export function globalBranchesSearchRequest({query}) {
  const url = URLParamBuilder(PATHS.SEARCH_BRANCHES, {
    queryString: query
  })

  return request<GetBranchServicesRequest["response"]>(url, {
    method: 'GET'
  });
}

// endregion

// region Fetch Branch Services
type FetchBranchServicesOptions = {
  params: GetBranchServicesRequest["parameters"]
}

export function fetchBranchServicesRequest({params}: FetchBranchServicesOptions) {
  const url = URLParamBuilder(PATHS.GET_BRANCH_SERVICES, {
    params
  })

  return request<GetBranchServicesRequest["response"]>(url, {
    method: 'GET',
    params: params
  });
}

// endregion

// region Fetch Agents
type FetchAgentsOptions = {}

export function fetchAgentsRequest({}: FetchAgentsOptions) {
  const url = URLParamBuilder(PATHS.FETCH_AGENTS, {})
  return request<GetAgentsRequest["response"]>(url, {});
}

// endregion

// region Fetch Branch Agents

// endregion

// region Change branch
type UpdateBranchRequestOptions = {
  params: UpdateBranchRequest["parameters"]
  payload: UpdateBranchRequest["payload"]
}

export function updateBranchRequest({params, payload}: UpdateBranchRequestOptions) {
  const url = URLParamBuilder(PATHS.UPDATE_BRANCH_API_PATH, {
    params
  })

  return request<UpdateBranchRequest["response"]>(url, {
    method: 'PATCH',
    data: payload,
  });
}

// endregion

// region Create Branch
type CreateBranchRequestOptions = {
  payload: CreateBranchRequest["payload"]
}

export function createBranchRequest({payload}: CreateBranchRequestOptions) {
  const url = URLParamBuilder(PATHS.CREATE_BRANCH_API_PATH)

  return request<CreateBranchRequest["response"]>(url, {
    method: 'POST',
    data: payload,
  });
}

// endregion


// region Delete Location
type DeleteBranchRequestOptions = {
  params: DeleteBranchRequest["parameters"]
}

export function deleteBranchRequest({params}: DeleteBranchRequestOptions) {
  const url = URLParamBuilder(PATHS.DELETE_BRANCH_API_PATH, {
    params
  })

  return request<DeleteUserRequest["response"]>(url, {
    method: 'DELETE'
  });
}

// endregion


// region Change service
type UpdateServiceRequestOptions = {
  params: UpdateServiceRequest["parameters"]
  payload: UpdateServiceRequest["payload"]
}

export function updateServiceRequest({params, payload}: UpdateServiceRequestOptions) {
  const url = URLParamBuilder(PATHS.UPDATE_SERVICE_API_PATH, {
    params
  })

  return request<UpdateServiceRequest["response"]>(url, {
    method: 'PATCH',
    data: getCleanServicePayload(payload),
  });
}

// endregion

// region Create service
type CreateServiceRequestOptions = {
  payload: CreateServiceRequest["payload"]
}

export function createServiceRequest({payload}: CreateServiceRequestOptions) {
  const url = URLParamBuilder(PATHS.CREATE_SERVICE_API_PATH)

  return request<CreateServiceRequest["response"]>(url, {
    method: 'POST',
    data: getCleanServicePayload(payload),
  });
}

// endregion


// region Delete service
type DeleteServiceRequestOptions = {
  params: DeleteServiceRequest["parameters"]
}

export function deleteServiceRequest({params}: DeleteServiceRequestOptions) {
  const url = URLParamBuilder(PATHS.DELETE_SERVICE_API_PATH, {
    params
  })

  return request<DeleteUserRequest["response"]>(url, {
    method: 'DELETE'
  });
}

// endregion


// region CreateResource
type CreateResourceRequestOptions = {
  params: CreateResourceRequest["parameters"]
  payload: CreateResourceRequest["payload"]
}

export function createResourceRequest({params, payload}: CreateResourceRequestOptions) {
  const url = URLParamBuilder(PATHS.CREATE_RESOURCE_FOR_PROJECT, {
    params
  })

  return request<CreateResourceRequest["response"]>(url, {
    method: 'POST',
    data: payload,
  });
}

// endregion

// region Delete Resource
type DeleteResourceRequestOptions = {
  params: DeleteResourceRequest["parameters"]
}

export function deleteResourceRequest({params}: DeleteResourceRequestOptions) {
  const url = URLParamBuilder(PATHS.DELETE_RESOURCE_FOR_PROJECT, {
    params
  })

  return request<DeleteResourceRequest["response"]>(url, {
    method: 'DELETE'
  });
}

// endregion
// region Fetch Agents
type GetServiceOptions = {
  params: GetServiceRequest["parameters"]
}

export function getServiceRequest({params}: GetServiceOptions) {
  const url = URLParamBuilder(PATHS.GET_SERVICE, {
    params
  })
  return request<GetServiceRequest["response"]>(url, {
    method: 'GET',

  });
}

// endregion

type GetBranchOptions = {
  params: GetBranchRequest["parameters"]
}

export function fetchManageableBranches({query}) {
  const url = URLParamBuilder(PATHS.GET_MANAGED_BRANCHES,{
    queryString: query
  })
  return request<GetBranchRequest["response"]>(url, {
    method: 'GET',

  });
}
export function getBranchRequest({params}: GetBranchOptions) {
  const url = URLParamBuilder(PATHS.GET_BRANCH, {
    params
  })
  return request<GetBranchRequest["response"]>(url, {
    method: 'GET',

  });
}
export function fetchBranchServiceAvailabilityRequest({ params, query }: { params: any, query?: any }) {
  const url = URLParamBuilder(PATHS.FETCH_SERVICE_AVAILABILITY, { params, queryString: query })

  return request<AddAgentToBranchRequest["response"]>(url, {
    method: 'GET',
  })
}

export function fetchAgentAvailabilityRequest({ params, query }: { params: any, query?: any }) {
  const url = URLParamBuilder(PATHS.FETCH_AGENT_AVAILABILITY, { params, queryString: query })

  return request<AddAgentToBranchRequest["response"]>(url, {
    method: 'GET',
  })
}


// region Offering

export function fetchOfferingsRequest() {
  const url = URLParamBuilder(PATHS.FETCH_OFFERINGS)
  return request<GetBranchRequest["response"]>(url, {
    method: 'GET',
  });
}

export function createOfferingRequest({data}) {
  const url = URLParamBuilder(PATHS.CREATE_OFFERING)
  return request<GetBranchRequest["response"]>(url, {
    method: 'POST',
    data
  });
}

export function editOfferingRequest({params, data}: {params: {offeringId: string}, data: any}) {
  const url = URLParamBuilder(PATHS.EDIT_OFFERING, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'PUT',
    data
  });
}

export function deleteOfferingRequest({params}: {params: {offeringId: string}}) {
  const url = URLParamBuilder(PATHS.EDIT_OFFERING, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'DELETE',
  });
}

// endregion

// region Service Types

export function fetchServiceTypesRequest() {
  const url = URLParamBuilder(PATHS.FETCH_SERVICE_TYPES)
  return request<GetBranchRequest["response"]>(url, {
    method: 'GET',
  });
}

export function createServiceTypeRequest({data}) {
  const url = URLParamBuilder(PATHS.CREATE_SERVICE_TYPE)
  return request<GetBranchRequest["response"]>(url, {
    method: 'POST',
    data
  });
}

export function editServiceTypeRequest({params, data}: {params: {serviceTypeId: string}, data: any}) {
  const url = URLParamBuilder(PATHS.EDIT_SERVICE_TYPE, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'PATCH',
    data
  });
}

export function updateAllServicesForServiceTypeRequest({params}: {params: {serviceTypeId: string}}) {
  const url = URLParamBuilder(PATHS.UPDATE_ALL_SERVICES_FOR_SERVICE_TYPE, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'POST',
    data: {}
  });
}

export function deleteServiceTypeRequest({params}: {params: {serviceTypeId: string}}) {
  const url = URLParamBuilder(PATHS.DELETE_SERVICE_TYPE, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'DELETE',
  });
}

export function guessServiceTypeIconRequest({data}: {data: {name: string}}) {
  const url = URLParamBuilder(PATHS.GUESS_SERVICE_TYPE_ICON)
  return request<GetBranchRequest["response"]>(url, {
    method: 'POST',
    data
  });
}

export function deleteServiceTypeThumbnailRequest({params}: {params: {serviceTypeId: string}}) {
  const url = URLParamBuilder(PATHS.UPLOAD_THUMBNAIL_FOR_SERVICE_TYPE, {params})
  return request<GetBranchRequest["response"]>(url, {
    method: 'DELETE',
  });
}

export function reorderServiceTypesRequest({data}: {data: {service_types: string[]}}) {
  const url = URLParamBuilder(PATHS.REORDER_SERVICE_TYPES)
  return request(url, {
    method: 'POST',
    data,
  });
}

// endregion
